import React from 'react';
import styled from 'styled-components'
import CrosstabViewReactTable from './CrosstabViewReactTable';
//import rows from './rows.json';
//import columns from './columns.json';
import rows from './rows-bushmill.json';
import columns from './columns-bushmill.json';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../autocode/AutocodeLabelsGenerator';
import { uniqueId } from 'lodash-es';
// import readrows from './readrows.json';


const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);

const CrosstabDummy = () => {

  const Styles = styled.div`
  padding: 1rem;

  .table {
    display: inline-block;
    background: #FFFFFF;
    /* Lines and Borders */
    
    border: 2px solid #DEDEDE;
    box-sizing: border-box;
    border-radius: 0px;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

    .tr {
      .td, .th {
        :first-child {
          color: #000
          //styleName: Body Bold 14px - Title, Links;
           font-family: "Open Sans";
           font-size: 12px;
           font-style: normal;
           font-weight: 700;
           line-height: 17px;
           letter-spacing: 0.10000000149011612px;
           text-align: left; 
        }
      }
    }

    .tr {
      .td, .th {
        //styleName: Body Reg 14px - Text;
        font-family: "Open Sans";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0.25px;
        text-align: left;
        
      }
    }

  .tr{
    :first-child {
      .th {
         color: #000
         //styleName: Body Bold 14px - Title, Links;
          font-family: "Open Sans";
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: 17px;
          letter-spacing: 0.10000000149011612px;
          text-align: left;

      }
    }
  }

    .th,
    .td {
      margin: 0;
      padding: 0.5rem;
      border: 1px solid #DEDEDE;
      background-color: #fff;
      overflow: hidden;

      :last-child {
        border-right: 0;
      }

      .resizer {
        display: inline-block;
        width: 5px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        transform: translateX(50%);
        z-index: 1;

        &.isResizing {
          background: red;
        }
      }
    }
    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }
 
      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }
 
      .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
      }
 
      .body {
        position: relative;
        z-index: 0;
      }
 
      [data-sticky-td] {
        position: sticky;
      }
 
      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }
 
      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }
`

  const DEFAULT_CELL_ELEMENTS = [
    {
      key: 'sample',
      isVisible: true,
      label: 'Unweig',
    },
    {
      key: 'weighted',
      isVisible: true,
      label: 'weight',
    },
    {
      key: 'vertical',
      isVisible: true,
      label: 'Vertic',
    },
    {
      key: 'horizontal',
      isVisible: true,
      label: 'Hor',
    },
    {
      key: 'index',
      isVisible: true,
      label: 'Index',
    },
  ];
  const partsToShow = {
    showCat: true,
    showSCats: true,
    showQ: true,
    showA: true,
  };
  const isVisibleCount =  DEFAULT_CELL_ELEMENTS.filter((cell) => cell.isVisible).length;
  const rowHeight = 134/isVisibleCount;
 function cvRowCell({value}) {
  // console.log("in console log cvRowCell")
  return (       
          <React.Fragment>
             {
               value.map(cell => {
                  return <div class='' title={Object.keys(cell)} style={{height: `${rowHeight}px`, display: 'flex', justifyContent: 'left', alignItems: 'left'}}> {Object.values(cell)}</div>
              })

              }
          </React.Fragment>
  )
 }

 function cvMetricCellHeader() {
  // console.log("in console log cvMetricCellHeader")
 return (       
          <React.Fragment>
           {
               DEFAULT_CELL_ELEMENTS.map(cell => {
                 if(cell.isVisible) {
                   return <div class='' title={cell.key} style={{height: `${rowHeight}px`, display: 'flex', justifyContent: 'left', alignItems: 'left'}}> {cell.label}</div>
                 }
               })
           }
         </React.Fragment>
 )
}

 const buildCrosstabViewColumns = () => {
  /*
  const bushrows = [];
  readrows.map(row => {
    bushrows.push({rowHeader: row.rowHeader,
      cellList: row.cellList,
      autocodenode: row.autocodenode? row.autocodenode: ''});
  })
  let textFile = null;
  const data = new Blob([bushrows], { type: 'octet/stream' });
  // If we are replacing a previously generated file we need to manually
  // revoke the object URL to avoid memory leaks.
  if (textFile !== null) {
    window.URL.revokeObjectURL(textFile);
  }
  textFile = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = textFile;
  link.download = `maddy.json`;
  link.click();
*/

  const tableColumns = [];
  tableColumns.push({
    Header: () => null,
    id: uniqueId(),
    sticky: 'left',
    accessor: 'rowName',
    width: 220,
  });
  tableColumns.push({
   Header: () => null,
   id: uniqueId(),
   sticky: 'left',
   width: 92,
   accessor: 'metricHeader',
   Cell: cvMetricCellHeader,
 });
 tableColumns.push({
  Header: 'All',
  id: uniqueId(),
  sticky: 'left',
  width: 124,
  accessor: 'col_0',
  Cell: cvRowCell,
});
 columns.map((col, index) => {
   const header = toLabelString(col.autocodenode, partsToShow, true).substring(0, 150);
   tableColumns.push({
     Header: header.substring(0, 150),
     id: uniqueId(),
     accessor : `col_${index+1}`,
     Cell: cvRowCell,
     width: 218
   })
 });
 return tableColumns;
}

const buildCrosstabViewRows = () => {
  function makeRow(row) {
    let tableRow = {};
    tableRow['rowName'] = row.autocodenode ? toLabelString(row.autocodenode, partsToShow, true).substring(0, 150): 'All';
    tableRow['metricHeader'] = '';
    row.cellList.map((rowCell, index)=> {
      let cellContent = [];
       DEFAULT_CELL_ELEMENTS.map(cell => {
         if(cell.isVisible) {
           let cellData = new Object();
           cellData[cell.key] = rowCell[cell.key]
            cellContent.push(cellData);
         }
       });
       tableRow[`col_${index}`] = cellContent;
     });
     return tableRow
  }
 
  const tableRows = [];
  rows.map((row, index) => {
   tableRows.push(makeRow(row));
  });
  return tableRows;
}

const ctColumns = React.useMemo(() => buildCrosstabViewColumns(), []);
const ctRowData = React.useMemo(() => buildCrosstabViewRows(), []);

  return (
    <div>
      <Styles>
        <CrosstabViewReactTable  columns={ctColumns} data={ctRowData} />
      </Styles>
    </div>
  )
}

export default CrosstabDummy